import { createRoute } from "@tanstack/react-router";
import { requirePermissions } from "@/app/guards";
import { EMAIL_TEMPLATES_PERMISSIONS } from "@/app/nav";
import { EmailTemplateList } from "@/features/email/EmailTemplateList";
import { EmailTemplatePage } from "@/features/email/EmailTemplatePage";
import { staffRoute } from "@/routes/staff";

/** archived=1 also lists archived templates. */
export type EmailTemplatesSearch = { archived?: 1 };

export const emailTemplatesRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "email-templates",
  // Set, never omit, each key: the router merges this over the raw query string.
  validateSearch: (search: Record<string, unknown>): EmailTemplatesSearch => ({
    archived: search.archived === 1 || search.archived === "1" ? 1 : undefined,
  }),
  beforeLoad: ({ context }) => requirePermissions(context.session, EMAIL_TEMPLATES_PERMISSIONS),
  component: EmailTemplateList,
});

export const emailTemplateDetailRoute = createRoute({
  getParentRoute: () => staffRoute,
  path: "email-templates/$templateId",
  beforeLoad: ({ context }) => requirePermissions(context.session, EMAIL_TEMPLATES_PERMISSIONS),
  component: EmailTemplatePage,
});
